/*
 * Copyright (c) 2024. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

export const handleArrayPaste = <T extends Array<unknown>>(
  e: React.ClipboardEvent<HTMLDivElement>,
  i: number,
  value: T,
) => {
  const data = e.clipboardData?.getData('text');
  if (!data) return value;
  const pasted = data
    .split('\n')
    .map((row) => row.split('\t')[0])
    .map(stripCarriageReturns)
    .slice(0, value.length);
  const newArr = [...value.slice(0, i), ...pasted, ...value.slice(i + pasted.length, value.length)];
  e.preventDefault();
  return newArr as T;
};

export const stripCarriageReturns = (value: string) => value.replace(/\r/g, '');
